<template>
  <div class="Home">
    <ShortPresen :InfoView="IberoPresen"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ShortPresen from '@/components/dashboard/Shortcuts.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'Home',
  data () {
    return {
      modelLogs: {
        Fuente: 'http://intranet.ibero.edu.co/',
        Pagina: 'Dashboard',
        Accion: 'Entro',
        Sesion: 1,
      },
    }
  },
  components: { ShortPresen },
  methods: {
  },
  computed: {
    ...mapState(['IberoPresen']),
  },
  created () {
    IberoHelpers.sendDataLogIntranet(this.$store, this.modelLogs)
  },
}
</script>

<style lang="scss">

</style>
